import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, TitleStrategy } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { errorInterceptor } from './app/core/interceptors/error.interceptor';
import { tenantInterceptor } from './app/core/interceptors/tenant.interceptor';
import { CmTitleStrategy } from './app/core/strategies/cm-title.strategy';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        tenantInterceptor,  // First: Add tenant headers
        authInterceptor,     // Second: Add auth token
        errorInterceptor     // Last: Handle errors
      ])
    ),
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: '+0530' } },
    { provide: TitleStrategy, useClass: CmTitleStrategy }
  ]
}).catch(err => console.error(err));
